import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CmsDataHome } from 'src/app/models/cmsdata';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public data: CmsDataHome|undefined;
  public backgroundImage: string = "unset";

  constructor(
    private router: Router,
    private dataService: DataService
  ) {
    this.subscribe();
  }

  ngOnInit(): void {
  }

  subscribe() {
    this.dataService.home.subscribe((data) => {
      this.data = data;
      if (this.data?.background_image) {
        this.backgroundImage = `url('${this.data.background_image}')`;
      } else {
        this.backgroundImage = "unset";
      }
    });
  }

  startExploring() {
    this.router.navigate(["/map"]);
  }

  openUrl($event: any, url: string) {
    if ($event) {
      $event.preventDefault();
    }
    window.open(url, "_blank");
  }

}
